import React, { useContext, useEffect } from 'react';
import tw from 'twin.macro';
import { Container } from '../container';
import { Ads, LazyloadAds, setAdsHeightPlaceholder } from '../ads';
import { quotes } from '../../data';
import { AppContext, PreferenceContext } from '../context';

const Aside = ({ sideBar, ...restProps }) => {
  return (
    <aside tw='order-last 2xl:col-span-2 grid-cols-1' {...restProps}>
      {sideBar}
    </aside>
  );
};

const adTypesHeader = {
  MOBILE: 'mediumrectangle',
  TABLET: 'billboard',
  DESKTOP: 'leaderboardwallpaper',
};

const adTypesFooter = {
  MOBILE: {
    type: 'interscroller',
    number: 'b1',
  },
  TABLET: {
    type: 'billboardrectangle',
    number: 'b2',
  },
};

export const Main = ({
  children,
  SideBar,
  detailPage = false,
  isModal = false,
  sideBarLeft,
  noSpacing = false,
  showAds = true,
  smallWidth = false,
  textPage = false,
  noMaxWidth,
  currentItemId,
  ...restProps
}) => {
  const { windowSize } = useContext(AppContext);
  const {
    preference: { sideBarLeftSide, commentsUnderVideo },
  } = useContext(PreferenceContext);
  const sideBarOnTheLeft = sideBarLeftSide || sideBarLeft;
  const showSidebar = (SideBar && !detailPage) || (SideBar && detailPage && !commentsUnderVideo);

  useEffect(() => {
    if (!textPage)
      setTimeout(() => setAdsHeightPlaceholder(document.querySelector('[id$="-t1"]')), 5000);
  }, []);

  return (
    <Container
      noSpacing={noSpacing}
      noMaxWidth={noMaxWidth}
      css={[
        detailPage && tw`px-0 lg:px-4`,
        !(detailPage || isModal) && tw`min-h-[calc(100vh - 6rem)] pb-24`,
        smallWidth && tw`w-full sm:w-[450px] text-center px-4 m-auto py-12`,
        textPage && tw`w-full max-w-4xl px-4 m-auto pt-12`,
      ]}
      {...restProps}
    >
      {showAds && !detailPage && !textPage && ['MOBILE'].includes(windowSize.adBreakPoint) && (
        <div css={[tw`h-[250px] bg-ads bg-opacity-20 w-screen -mx-2`]}>
          <Ads quotesList={quotes} adType='mediumrectangle' adNumber='t1' tw='mx-auto' />
        </div>
      )}
      {showAds && !detailPage && !textPage && !['MOBILE'].includes(windowSize.adBreakPoint) && (
        <div
          css={[
            tw`h-[250px] bg-ads bg-opacity-20 flex justify-center text-center lg:my-4 md:rounded-lg`,
          ]}
        >
          <Ads quotesList={quotes} adType={adTypesHeader[windowSize.adBreakPoint]} adNumber='t1' />
        </div>
      )}
      {showAds && detailPage && !['MOBILE'].includes(windowSize.adBreakPoint) && (
        <>
          <div css={[tw`max-h-[250px] overflow-y-hidden mb-4`]}>
            <Ads collapsed adType={adTypesHeader[windowSize.adBreakPoint]} adNumber='t1' />
          </div>
        </>
      )}
      <Container
        noSpacing
        noMaxWidth={noMaxWidth}
        css={[
          showSidebar && tw`flex flex-col lg:grid lg:grid-cols-3 2xl:grid-cols-7 gap-4 xl:gap-6`,
        ]}
      >
        {showSidebar && (
          <Aside
            sideBar={SideBar}
            css={[!sideBarOnTheLeft && tw`lg:order-last`, sideBarOnTheLeft && tw`lg:order-first`]}
          />
        )}
        <div css={[showSidebar && tw`sm:col-span-2 2xl:col-span-5`]}>{children}</div>
      </Container>
      {showAds && detailPage && !['DESKTOP'].includes(windowSize.adBreakPoint) && (
        <Ads
          Type={LazyloadAds}
          adType={adTypesFooter[windowSize.adBreakPoint].type}
          adNumber={adTypesFooter[windowSize.adBreakPoint].number}
          tw='mt-4 mb-16'
        />
      )}
    </Container>
  );
};
